// 首页弹窗的逻辑抽离
import AllDialog from './components/all-dialog'
import DialogManager from './components/dialog-manager'
import { getKey, setKey } from '@/assets/utils'

let popup 
export default {
  created () {
    const dialogManager = new DialogManager()
    popup = dialogManager.popup.bind(dialogManager)
  },
  methods: {
    async dealActivity (_popAndHomeArray) {
      let popAndHomeArray = _popAndHomeArray
      /**
       * jira 4420 校验是否有自动跳转的弹窗
       * {规则} 如果有自动跳转的弹窗 根据autoJumpDay判断展示周期 通过autoJump判断是否要跳转
       * 如果有要跳转的 抽离出这个弹窗 与其他弹窗互斥
       */

      const autoPopUp = popAndHomeArray?.filter((item) => item.autoJump === 'Y')
      
      if (autoPopUp?.length && this.isIntervalDay(`POPUP_AUTO_JUMP`, autoPopUp[0].autoJumpDay)) {
        const autoJumpPopup = popAndHomeArray.find((item) => item.autoJump === 'Y')
        popAndHomeArray = [autoJumpPopup]
        setKey('POPUP_AUTO_JUMP', new Date().getTime())
      } else {
        popAndHomeArray = popAndHomeArray.map((item) => {
          return {
            ...item,
            autoJump: 'N'
          }
        })
      }
      popAndHomeArray.map((item) => {
        if (item.popUpType === 'OPERATION') {
          this.popupConfigDialog(item)
        } else if (item.couponV3 === 'Y') {
          // v3的券 额度 免息 红包
          this.popupCouponV3Dialog(item)
        } else {
          switch (Number(item.caseId)) {
            case 10:
              this.popupRedPacketDialog(item)
              break
            case 14:
              this.popupWithdrawDialog(item)
              break
            case 15:
              this.popupCreditDialog(item)
              break
            case 16:
            case 21:
              this.popupConfigurableDialog(item)
              break
            case 24:
            case 25:
            case 27:
              this.popupNewComerDialog(item)
              break
            case 29:
              this.popupNewYearDialog(item, 1)
              break
            case 30:
              this.popupNewYearDialog(item, 2)
              break
            case 33:
              this.popupDrainageDialog(item)
              break
            case 120:
            case 121:
              this.popupBuyVipDialog(item)
              break
            case 127:
              this.popupNewbieActivityDialog(item)
              break
            case 131:
              this.popupSupremeDialog(item)
              break
            case 135:
            case 136:
            case 137:
            case 140:
              this.popupRiskControlDialog(item)
              break
            case 138:
            case 139:
              this.popUpByActive(item)
              break
            case 145:
              this.popupFllowTmdAccountDialog(item)
              break 
            case 151: // 进入预览提现没有提现的挽留红包 老客预览提现优惠弹窗:免息券
            case 152: // 老客预览提现优惠弹窗:高通资方
              this.popupRetain(item) 
              break 
            case 153: // 小花老客活动弹窗
              this.popupOldcustomerBonus(item) 
              break 
            case 155: // 还款引导送免息券
              this.popupBgAndVarRelace(item) 
              break 
            default:
              this.popupCommonDialog(item)
              break
          }
        }
      })
      this.dealShowCase()
      // 如果有活动弹窗优先展示
      if (!this.allActivity?.length) {
        this.getBorrowPopInfo()
      }
    },
    // 进入预览提现没有提现的挽留红包
    popupRetain (item) {
      // 每天弹一次
      if (this.isIntervalDay(`popupRetain${item.caseId}`, 1)) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'popupRetain',
          type: Number(item.caseId)
        })
        setKey(`popupRetain${item.caseId}`, Date.now())
      }
    },

    popupOldcustomerBonus (item) {
      // 自然周
      if (this.isIntervalNextMon(`popupOldcustomerBonusByweek${item.caseId}`)) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'popupOldcustomerBonus',
          type: Number(item.caseId)
        })
      }
    },
    
    // 处理天美贷弹窗
    dealShowCase () {
      let allData = JSON.parse(JSON.stringify(this.allActivity))
      if (allData.length > 0) {
        this.popupAllDialog(allData) // 所有活动
      }
    },
    popupAllDialog (item) {
      const allDialog = new AllDialog({ data: item }, this.$el)
      this.$nextTick(() => {
        popup(allDialog)
        allDialog.vm.$on('close', () => {
          this.getBorrowPopInfo()
        })
      })
    },
    popupBgAndVarRelace (item) {
      const { couponV3Rate } = item
      item.expiredContent = ''
      const EVERYTIME_ACTIVE_POP = true // 每次激活弹出
      const EVERYDAY_POP_LIMIT_ONE = couponV3Rate === 'EVERYDAY_POP_LIMIT_ONE' // 自然日弹出1次如果是自然日要取periodDay
      if ((EVERYTIME_ACTIVE_POP && this.isIntervalDayBySession(`couponV3${item.caseId}`, 1)) || (EVERYDAY_POP_LIMIT_ONE && this.isIntervalDay(`couponV3${item.caseId}`, item.periodDay))) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'couponV3Diaolog',
          type: Number(item.caseId)
        })
        if (EVERYTIME_ACTIVE_POP) {
          sessionStorage.setItem(`couponV3${item.caseId}`, Date.now())
        } 
        if (EVERYDAY_POP_LIMIT_ONE) {
          setKey(`couponV3${item.caseId}`, Date.now())
        }
      }
    },
    popupCouponV3Dialog (item) {
      const { couponV3Rate } = item
      const EVERYTIME_ACTIVE_POP = couponV3Rate === 'EVERYTIME_ACTIVE_POP' // 每次激活弹出
      const EVERYDAY_POP_LIMIT_ONE = couponV3Rate === 'EVERYDAY_POP_LIMIT_ONE' // 自然日弹出1次如果是自然日要取periodDay
      if ((EVERYTIME_ACTIVE_POP && this.isIntervalDayBySession(`couponV3${item.relationId}`, 1)) || (EVERYDAY_POP_LIMIT_ONE && this.isIntervalDay(`couponV3${item.relationId}`, item.periodDay))) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'couponV3Diaolog',
          type: item.relationId
        })
        if (EVERYTIME_ACTIVE_POP) {
          sessionStorage.setItem(`couponV3${item.relationId}`, Date.now())
        } 
        if (EVERYDAY_POP_LIMIT_ONE) {
          setKey(`couponV3${item.relationId}`, Date.now())
        }
      }
    },
    popupRedPacketDialog (item) {
      // nextstep 'CREDIT', 'LOAN', 'OCR', 'INFO' 时弹出立即领取样式
      if (
        ['CREDIT', 'OCR', 'INFO', 'CREDIT_REVIEW'].includes(item.nextStep) &&
        (this.isIntervalDay('RED_PACKET_1_SHOW_TIME', 1) || this.nowPopGroup)
      ) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'redPacketDialog1'
        })
      }

      // nextstep'为'FINAL'  时弹出'开字'红包样式
      // 并且 不是 「不在弹出的的标识]
      if (
        item.nextStep === 'FINAL' &&
        (this.isIntervalDay('RED_PACKET_2_SHOW_TIME', 1) || this.nowPopGroup) &&
        getKey('RED_PACKE_SHOULD_SHOW') !== 'F'
      ) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'redPacketDialog2'
        })
      }
    },
    popupWithdrawDialog (item) {
      if (this.isIntervalDay('WITHDRAW_DIALOG_SHOW_DATE', 1)) {
        this.withdrawDialog = true
        setKey('WITHDRAW_DIALOG_SHOW_DATE', Date.now())
      }
    },
    popupCreditDialog (item) {
      if (this.isIntervalDay('CREDIT_DIALOG_SHOW_DATE', 1)) {
        this.creditDialog = true
        setKey('CREDIT_DIALOG_SHOW_DATE', Date.now())
      }
    },
    popupConfigurableDialog (item) {
      if (item.nextStep === 'LOAN') {
        // 可借款
        if (
          this.isIntervalDay(
            `INTEREST_FREE_DIALOG_1_SHOW_TIME${this.userInfo.mobile}`,
            1
          ) ||
          this.nowPopGroup
        ) {
          this.allActivity.push({
            data: item,
            mobile: this.userInfo.mobile,
            model: 'interestFreeDialog1'
          })
        }
      } else {
        // 未授信
        if (
          this.isIntervalDay(
            `INTEREST_FREE_DIALOG_2_SHOW_TIME${this.userInfo.mobile}`,
            1
          ) ||
          this.nowPopGroup ||
          !this.checkUserInfo
        ) {
          this.allActivity.push({
            data: item,
            mobile: this.userInfo.mobile,
            model: 'interestFreeDialog2',
            isLogin: this.checkUserInfo
          })
        }
      }
    },
    popupNewComerDialog (item) {
      // 新人活动弹窗
      // nextStep 为ocr，弹出第一种样式弹窗， 表示去认证
      if (
        (['OCR'].includes(item.nextStep) || item.nextStep === null) &&
        (this.isIntervalDay('NEW_COMER_1_SHOW_TIME', 1) ||
        this.nowPopGroup ||
        !this.checkUserInfo)
      ) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'newComerDialog1',
          isLogin: this.checkUserInfo
        })
      }

      // nextStep 为LOAN，弹出第二种样式弹窗， 表示去提现
      if (
        ['LOAN', 'INFO', 'CREDIT'].includes(item.nextStep) &&
        (this.isIntervalDay('NEW_COMER_2_SHOW_TIME', 1) || this.nowPopGroup)
      ) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'newComerDialog2'
        })
      }
      // nextStep 为FINAL，弹出第三种样式弹窗， 表示已经提现完成， 去关注公众号
      if (
        item.nextStep === 'LOAN_PASSED' &&
        (this.isIntervalDay('NEW_COMER_3_SHOW_TIME', 1) || this.nowPopGroup) &&
        !getKey('no-more-popups')
      ) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'newComerDialog3'
        })
      }
    },
    popupNewYearDialog (item, index) {
      if (
        ((item.nextStep === 'LOAN' || item.nextStep === 'LOAN_PASSED') &&
        item.couponStatus === 'PRE_PROVIDE') ||
        index === 1
      ) {
        if (
          (this.isIntervalDay('newYear1', 1) || this.nowPopGroup) &&
          index === 1
        ) {
          this.allActivity.push({
            data: item,
            mobile: this.userInfo.mobile,
            model: 'common',
            type: index
          })
        } else if (
          (this.isIntervalDay('newYear2', 1) || this.nowPopGroup) &&
          index === 2
        ) {
          this.allActivity.push({
            data: item,
            mobile: this.userInfo.mobile,
            model: 'common',
            type: index
          })
        }
      }
    },
    popupDrainageDialog (item) {
      if (
        ['OCR', 'LOAN'].includes(item.nextStep) &&
        (this.isIntervalDay('DRAINAGE_SHOW_TIME', 1) || this.nowPopGroup)
      ) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'drainageDialog'
        })
      }
    },
    // 小美首页购卡引导
    popupBuyVipDialog (item) {
      if (this.isIntervalDay(`newYear${item.caseId}`, 1)) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'vipDialog',
          type: Number(item.caseId)
        })
        setKey(`newYear${item.caseId}`, Date.now())
      }
    },
    popupNewbieActivityDialog (item) {
      if (this.isIntervalDay(`newYear${item.caseId}`, 1)) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'newbieActivityDialog',
          type: Number(item.caseId)
        })
        setKey(`newYear${item.caseId}`, Date.now())
      }
    },
    popupSupremeDialog (item) {
      if (this.isIntervalDay(`newYear${item.caseId}`, 1)) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'supremeDialog',
          type: Number(item.caseId)
        })
        setKey(`newYear${item.caseId}`, Date.now())
      }
    },
    // 135  风控老客召回 - 有有效的临时额度
    // 136  风控老客召回 - 有有效的免息券
    // 137  风控老客召回-无有效的临时额度且无有效的免息券-额度利用率[50%，80%)
    // 140  有有效的临时额度（来源：含有业务系统有效提额）
    popupRiskControlDialog (item) {
      const dialogModel = {
        '135': 'riskControlDialog1',
        '136': 'riskControlDialog2',
        '137': 'riskControlDialog3',
        '140': 'riskControlDialog6'

      }
      if (this.isIntervalDay(`riskControl${item.caseId}`, item.periodDay)) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: dialogModel[item.caseId],
          type: Number(item.caseId)
        })
        setKey(`riskControl${item.caseId}`, Date.now())
      }
    },
    // 138  无有效的临时额度且无有效的免息券-额度利用率
    // 139  无有效的临时额度且无有效的免息券-额度利用率【0%，20%）
    popUpByActive (item) {
      const dialogModel = {
        '138': 'riskControlDialog4',
        '139': 'riskControlDialog5'
      }
     
      if (this.isIntervalDayBySession(`riskControl${item.caseId}`, 1)) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: dialogModel[item.caseId],
          type: Number(item.caseId)
        })
        sessionStorage.setItem(`riskControl${item.caseId}`, Date.now())
      }
    },
    // 关注天美贷公众号弹窗
    popupFllowTmdAccountDialog (item) {
      if (this.isIntervalDay(`fllowTmdAccount${item.caseId}`, item.periodDay)) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'fllowTmdAccountDialog',
          type: Number(item.caseId)
        })
        setKey(`fllowTmdAccount${item.caseId}`, Date.now())
      }
    },
    popupCommonDialog (item) {
      if (this.nowPopGroup || this.isIntervalDay(`newYear${item.caseId}`, 1)) {
        this.allActivity.push({
          data: item,
          mobile: this.userInfo.mobile,
          model: 'common',
          type: Number(item.caseId)
        })
      }
    }

  }
}